import moment from "moment";
import { headersConfigData } from "../_commonServices/commonServices";
// ===================================================== Login Api Requests Start ==================================================== //

const loginUser = (uname, pass) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/Account/JsonLogin`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      UserName: uname,
      Password: pass,
    }),
  });

const sendLinkToEmailForResetPasswordApiCall = (email) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/UserDetails/SendEmailToResetPassword?EmailAddress=${encodeURIComponent(email)}`,
    {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      }
    }
  );

const resetUsernameApiCall = (email) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/UserDetails/SendEmailUsernameReminder?EmailAddress=${encodeURIComponent(email)}`,
    {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      }
    }
  );

const changePasswordApiCall = (newPass, uname) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/UserDetails/ChangePassword?NewPassword=${encodeURIComponent(newPass)}&UserName=${encodeURIComponent(uname)}`,
    {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      }
    }
  );

const resetPasswordApiCall = (newPass, passwordResetToken) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/UserDetails/ChangePasswordForPasswordResetToken?NewPassword=${encodeURIComponent(newPass)}&PasswordResetToken=${encodeURIComponent(passwordResetToken)}`,
    {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      }
    }
  );

// ===================================================== Login Api Requests End ==================================================== //

// ===================================================== Map Module API Requests Start ================================================= //

export const getCarsApiCall = (
  lastQueryData,
  headersConfigData,
  siteId
) => {
  if (lastQueryData && headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCars?theSiteId=${siteId}&theLastQueryDate=${encodeURIComponent(
        lastQueryData
      )}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const clickToDriveApiCall = (
  carIdData,
  carLat,
  carLang,
  siteId,
  headersConfigData
) => {
  if (
    carIdData &&
    carLat &&
    carLang &&
    siteId &&
    headersConfigData()
  ) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/SetClickToDrive`,
      {
        method: "post",
        headers: headersConfigData(),
        body: JSON.stringify({
          carIds: carIdData,
          latitude: carLat,
          longitude: carLang,
          siteId: siteId,
        }),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getActionZoneApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetActionZones?theSiteId=${siteId}`,
    {
      headers: headersConfigData(),
    }
  );

const getPackageManifestsApiCall = (headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetPackageManifests`, {
    headers: headersConfigData(),
  });

const assignManifestToCarsApiCall = (
  manifestId,
  siteId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/AssignManifestToCars?manifestId=${manifestId}&siteId=${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const getFaultsCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetFaults?theSiteId=${siteId}`,
    {
      headers: headersConfigData(),
    }
  );

const getHoleMarkerApiCall = (headersConfigData, siteId) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetHoleNumberMarkers?theSiteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const sendMessagesApiCall = (
  msgInput,
  Options,
  gpsiCarId,
  siteId,
  headersConfigData
) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/SendMessageToCars`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify({
      SiteId: siteId,
      Text: msgInput,
      Options: Options,
      TargetIds: gpsiCarId,
    }),
  });

const getCannedMessagesApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCannedMessages?SiteId=${siteId}`,
    {
      headers: headersConfigData(),
    }
  );

const getMapImageApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetMapImage?siteId=${siteId}`,
    {
      headers: headersConfigData(),
    }
  );

const getXYPointsInImageApiCall = async (headersConfigData, imageXYPointsRequest) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetXYPointsInImage?siteId=${imageXYPointsRequest.SiteId}&latitude=${imageXYPointsRequest.Latitude}&longitude=${imageXYPointsRequest.Longitude}&xScale=${imageXYPointsRequest.XScale}&xRotate=${imageXYPointsRequest.XRotate}&xOffset=${imageXYPointsRequest.XOffset}&yScale=${imageXYPointsRequest.YScale}&yRotate=${imageXYPointsRequest.YRotate}&yOffset=${imageXYPointsRequest.YOffset}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response;
  } catch (error) {
    console.error("Error in getXYPointsInImageApiCall:", error);
    throw error;
  }
};

const setkmlLayerApiCall = (headersConfigData, siteId) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetKmlUrl?siteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getCarTrackApiCall = (payload, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarTrack?SiteId=${siteId}&gpsiCarId=${payload.gpsiCarId}&hoursBack=${payload.hoursBack}`,
    {
      headers: headersConfigData(),
    }
  );

const getCarPropertiesApicall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCars?theSiteId=${siteId}&theLastQueryDate=2022-06-23T10:32:38.330Z`,
    {
      headers: headersConfigData(),
    }
  );

const getCarLocationApicall = (headersConfigData, siteId) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarTrack?siteId=${siteId}&gpsiCarId=4593&hoursBack=36`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getUserNameAndRole = (headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/getUserNameAndRole`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getCarHistoryApiCall = (lastQueryDate, headersConfigData, siteId) => {
  return fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarHistoryCarList?theSiteId=${siteId}&theQueryDate=${lastQueryDate}`,
    {
      headers: headersConfigData(),
    }
  );
};

const getSpecificCarHistory = (carNumber, queryData, headersConfigData, siteId) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarHistoryForCars`, {
    method: "Post",
    headers: headersConfigData(),
    body: JSON.stringify({
      SiteId: siteId,
      Cars: carNumber,
      QueryDate: queryData,
    }),
  });

const getCarHistoryForAllCars = () =>
  fetch(
    `http://localhost:5000/GetCarHistoryForAllCars`
  );

const sendFleetSettingsWelcomeText = (
  textMessage,
  siteId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutWelcomeText?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(textMessage),
      headers: headersConfigData(),
    }
  );

const putCOGData = (payload, siteId, cogId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutHoleData/${cogId}/${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: headersConfigData(),
    }
  );

const getProductApicall = (payload, headersConfigData) => {
  if (payload && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetCarSettings?gpsiCarId=${payload?.GpsiCarId ? payload?.GpsiCarId : payload
      }`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const putDisableDistance = (mhDisableDist, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutMaxHolesExceededDistancesDisabled?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(mhDisableDist),
      headers: headersConfigData(),
    }
  );
const putRemovePersistentCarTypeSetting = (siteId, carNumber, carType) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/RemovePersistentCarTypeSetting?siteId=${siteId}&carNumber=${carNumber}&carType=${carType}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );
const postSavePersistentCarTypeSetting = (siteId, carNumber, carType, isPersistCarType) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SavePersistentCarTypeSetting?siteId=${siteId}&carNumber=${carNumber}&carType=${carType}&isPersistCarType=${isPersistCarType}`,
    {
      method: "POST",
      headers: headersConfigData(),
    }
  );
const putBehindPaceWarning = (bpWarning, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutBehindPaceWarning?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(bpWarning),
      headers: headersConfigData(),
    }
  );
const putPaceStatusTime = (paceStatus, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutPaceStatusTime?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(paceStatus),
      headers: headersConfigData(),
    }
  );
const putSiteOffPeakCharging = (payload, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/UpdateSiteOffPeakCharging?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: headersConfigData(),
    }
  );

const putMaxNumHoles = (maxHoles, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutMaxHoles?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(maxHoles),
      headers: headersConfigData(),
    }
  );

const putRoundStagingTimeoutApi = (payload, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutPaceSettings?siteId=${siteId}`,
    {
      method: "POST",
      body: JSON.stringify(payload),
      headers: headersConfigData(),
    }
  );

const getMessagesFromCarsApi = (siteId, oldest, headersConfigData) => {
  if (siteId && oldest && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetMessagesFromCars?siteId=${siteId}&oldest=${oldest}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const sendMessageToMarshalsApiCall = (messageId, sideId) => {
  if (messageId && sideId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/sendMessageToMarshals`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify({
          MessageId: messageId,
          SideId: sideId
        }),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const fetchPinsImagesApiCall = (src, headersConfigData) => {
  if (src) {
    return fetch(src, {
      headers: headersConfigData(),
    });
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getSiteSettingsApiCall = (
  headersConfigData,
  siteId
) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetSiteSettings?theSiteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing on /GetSiteSettings endpoint" };
  }
};

const getSiteSettingsApiCallHandler = (headersConfigData, siteId) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetSiteSettings?theSiteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getMapInformationApiCall = (
  courseNo,
  holeNo,
  mapType,
  headersConfigData,
  siteId
) => {
  if (courseNo && holeNo && mapType && headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetMapInformation?siteId=${siteId}&courseNumber=${courseNo}&holeNumber=${holeNo}&mapType=${mapType}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

export const getSiteSetupApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetSiteSetupData?theSiteId=${siteId}`,
    {
      headers: headersConfigData(),
    }
  );

const setSiteSetupApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendSiteData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const setTeeSetupApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendTeeMarkerData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const setPioSetupApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendPOIData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const setPublishSetupApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/ScheduleSiteDataPublish/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const getDashboardCartPathDetailApiCall = (
  headersConfigData,
  siteId,
  courseId
) => {
  if (headersConfigData() && courseId && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetDashboardCartPathDetail?theSiteId=${siteId}&courseId=${courseId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const sendScoreCardEmail = (email, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutScorecardEmail?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(email),
      headers: headersConfigData(),
    }
  );

const putMaxHolesExAlert = (mhAlert, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutMaxHolesExceededAlert?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(mhAlert),
      headers: headersConfigData(),
    }
  );

const putUpdateScheduleLockDown = (payload, siteId, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa//UpdateScheduledFleetLockdown/0?siteId=${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: headersConfigData(),
    }
  );
};

const getRoundTimeOutApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetPaceSettings?siteId=${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getScheduledFleetLockdownApiCall = (
  RecId,
  siteId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetScheduledFleetLockdown/${RecId}/${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getSiteOffPeakCharginApiCall = (RecId, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetSiteOffPeakCharging/${RecId}/${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getPartialSiteSettingsForUpdateApi = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetPartialSiteSettingsForUpdate?siteId=${siteId}&siteSetupStatus=true`,
    {
      headers: headersConfigData(),
    }
  );

const getProgressPendingForSiteApi = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/ManifestState/GetProgressPendingForSite?siteId=${siteId}&fromDate=2022-09-09`,
    {
      headers: headersConfigData(),
    }
  );

const getVersionStringApi = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/ManifestState/GetProgressPendingForSite?siteId=${siteId}`,
    {
      headers: headersConfigData(),
    }
  );
// ================================================== Fleet Module API Requests End ==================================================== //

// ============================================================= Message api call starts ==============================================//

const setSaveEmailApiCall = (payload, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveAlertEmailAddress/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const setDeleteEmailApiCall = (siteId, payload, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/DeleteAlertEmailAddress/${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const getAlertEmailApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetAlertEmailAddresses?SiteId=${siteId}`,
    {
      headers: headersConfigData(),
    }
  );

const setSendTestEmailApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/SendTestAlertEmail`, {
    method: "PUT",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const updateEmailApiCall = (siteId, payload, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/SaveAlertEmailAddress?Id=${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

export const getMessagesHistory = (
  siteId,
  startDate,
  endDate,
  headersConfigData
) => {
  let sData = moment(startDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  let eData = moment(endDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  let res = fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetMessageLogs?siteId=${siteId}&startDate=${encodeURIComponent(
      sData
    )}&endDate=${encodeURIComponent(eData)}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );
  return res;
};

// put canned message API message/setting/
const deleteMessagesSettingAPI_CALL = (Id, siteId, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteCannedMessage?siteId=${siteId}&id=${Id}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
    }
  );
};

// ########################### POST canned message for new entry  PutMessagesSettingAPI_CALL
const postCannedMessagesApiCall = (payload, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PostCannedMessage?siteId=${siteId}`,
    {
      method: "POST",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const PostSiteAreaApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/PostSiteArea`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const putSiteAreaApiCall = (payload, Id, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutSiteArea/${Id}/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const deleteSiteAreaAPI_CALL = (Id, headersConfigData, siteId) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteSiteArea/${Id}/${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
    }
  );
};
const postHoleAreaApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/PostHoleArea`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const putHoleAreaApiCall = (payload, Id, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutHoleArea/${Id}/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const deleteHoleAreaAPI_CALL = (Id, headersConfigData, siteId) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteHoleArea/${Id}/${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
    }
  );
};

//   Put message setting
const putMessagesSettingAPI_CALL = (payload, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutCannedMessage?siteId=${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const putMessagesSettingAPI_CALL2 = (payload, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutCannedMessage?siteId=${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const putMessagesSettingAPI_CALL3 = (payload, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutCannedMessages/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

// ######### message VDU API
const getWelcomeAdsApiCall = (headersConfigData, siteId) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetDashboardWelAdsForSite?SiteId=${siteId}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getDashboardPaceApiCall = (
  headersConfigData,
  siteId,
  LastQueryDate,
  courseId
) => {
  if (headersConfigData() && siteId && LastQueryDate && courseId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetDashboardPaceTiming?theSiteId=${siteId}&theLastQueryDate=${LastQueryDate}&CourseId=${courseId}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getVDUMessagesApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetVduMessages?SiteId=${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );
const putVDUMessagesApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/PutVduMessages/`, {
    method: "PUT",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

// ============================================================== Message api call ends ============================================= //

// =============================================== Fleet Module API Requests Start ==================================================== //

const setCurrentSettingApiCall = (payload, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutFleetSetting?SiteId=${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );
const putAllowAntiTamperSelectionApiCall = (payload, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutAllowAntiTamperSelection?siteId=${siteId}&allowAntiTamper=${payload}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const setCurrentSettingApiCall2 = (payload, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutFleetSetting/0/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const carStagingModeAPICall = (
  siteSettingData,
  headersConfigData,
  siteId
) => {
  if (siteId && headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/PutGuardianMode?id=${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(siteSettingData),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const putMaxVolumeSettingApiCall = (payload, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutMaxVolume/0/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

// =============================================== Fleet Module API Requests End ==================================================== //

// ===================================================== Pins Module API Request Start ==================================================== //

const getPinsApproachImagesApiCall = (
  siteIdData,
  imageName,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetApproachImage?siteId=${siteIdData}&name=${imageName}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getCarPinPlacementsApiCall = (siteId, headersConfigData) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetCarPinPlacements?theSiteId=${siteId}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getAllSiteLocations = (headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetSiteLocations`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getCustomerServiceProfiles = (headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/getCustomerServiceProfiles`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const saveCustomerServiceProfileSetting = (value, headersConfigData, siteId) => {
  if (value && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveCustomerServiceProfileSetting/0/${siteId}`,

      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(value),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getGreensWithPinPlacementsApiCall = (
  siteId,
  courseNumberGetter,
  headersConfigData
) => {
  if (siteId && courseNumberGetter() && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GreensWithPinPlacements?theSiteId=${localStorage.getItem("recentSite")
        ? localStorage.getItem("recentSite")
        : siteId
      }&theCourseId=${localStorage.getItem("courseId")
        ? localStorage.getItem("courseId")
        : courseNumberGetter()
      }`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const updateEzLocatorPins = (
  siteId,
  courseNumberGetter,
  date,
  headersConfigData
) => {
  if (siteId && courseNumberGetter && headersConfigData) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/Pins/UpdateEzLocatorPins?siteId=${siteId}&courseNumber=${courseNumberGetter}&pinSheetDate=${date}`,
      {
        method: "POST",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getRotationDataApiCall = (
  siteId,
  courseNumber,
  headersConfigData
) => {
  if (siteId && courseNumber && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GreensWithPinPlacements?theSiteId=${siteId}&theCourseId=${courseNumber}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const courseRotationDataApiCall = (courseRotationData, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveCourseRotationSets`,
    {
      method: "POST",
      headers: headersConfigData(),
      body: JSON.stringify(courseRotationData),
    }
  );

const updatePinsRotationsDataApiCall = (
  courseRotationData,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveCourseRotationSets`,
    {
      method: "POST",
      headers: headersConfigData(),
      body: courseRotationData,
    }
  );

export const updateCarTypeApiCall = (payload, headersConfigData) => {
  if (payload && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutCarSettings/${payload.GpsiCarId}`,

      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(payload),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};
export const updateMemberCarTrackingLevelApiCall = (payload, siteID, headersConfigData) => {
  //As payload can be zero, cant do payload && siteID
  if ((payload ?? '') !== '' && siteID && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutMemberCarTrackingLevel/0/${siteID}`,

      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(payload),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};
const saveCourseRotationDaysApiCall = (
  courseRotationDaysData,
  headersConfigData
) => {
  if (courseRotationDaysData && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveCourseRotationDays`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify(courseRotationDaysData),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

// ===================================================== Pins Module API Request End ==================================================== //

// ====================================== Site Data Configuration Module API Request Start ============================================ //

const enableAllAZsForMemberCarsApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/EnableAllAZsForMemberCars?siteId=${siteId}`,
    {
      method: "POST",
      headers: headersConfigData(),
    }
  );

const disableAllAZsForMemberCarsApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DisableAllAZsForMemberCars?siteId=${siteId}`,
    {
      method: "POST",
      headers: headersConfigData(),
    }
  );

const resetSiteExtentsAndCtrPtToZeroApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/ResetSiteExtentsAndCtrPtToZero?siteId=${siteId}`,
    {
      method: "POST",
      headers: headersConfigData(),
    }
  );

const setSiteExtentsApiCall = (payload, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SetSiteExtents`,
    {
      method: "POST",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const createSiteDataApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/CreateSiteData`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const resetTeeMarkersVersionApiCall = (payload, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/ResetTeeMarkersVersion`,
    {
      method: "POST",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const resetMapsVersionApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/ResetMapsVersion`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const resetGreenViewVersionApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/ResetGreenViewsVersion`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const resetPOIsVersionApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/ResetPOIsVersion`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const clearSiteDataApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/ClearSiteData`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const sendTeeMarkerDataApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendTeeMarkerData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const scheduleSiteDataPublishApiCall = (
  siteId,
  headersConfigData
) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/ScheduleSiteDataPublish/${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const sendPOIDataApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendPOIData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const sendSiteDataApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendSiteData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const sendMapDataApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendMapData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const sendGreenViewDataApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SendGreenViewData/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const resetSiteDataVersionApiCall = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/ResetSiteDataVersion`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

// ============================================ Site Data Configuration Module API Request End ======================================== //

const getVisageUsersApiCall = (headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetVisageUsers`, {
    method: "GET",
    headers: headersConfigData(),
  });

const getVisageUsersListApiCall = (headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetVisageUsersList`, {
    method: "GET",
    headers: headersConfigData(),
  });

const getRolesListApiCall = (headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetRolesList`, {
    method: "GET",
    headers: headersConfigData(),
  });

const getPrivilegesListApiCall = (headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetPrivilegesList`, {
    method: "GET",
    headers: headersConfigData(),
  });

const getPrivilegeApiCall = (privilege, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/GetPrivilege?privilege=${privilege}`, {
    method: "GET",
    headers: headersConfigData(),
  });

// ===================================================== Ads Module API Request Start ==================================================== //

const getImageGallaryApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetImagesForSite?siteId=${siteId}
    `,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

export const getAdImageApiCall = (imageId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetAdImage?siteId=0&id=${imageId}
    `,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const putImageDescriptionAPICall = (desc, imageId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutImageDescription/${imageId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(desc),
    }
  );

const deleteImageAPICall = (imageId, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteImage/${imageId}`,
    {
      method: "PUT",
      headers: headersConfigData()
    }
  );
};

const saveCampaignDetailAPICall = (siteId, payload, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveCampaignDetailForSite/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );
};

const saveWorksheetAPICall = (payload, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveAdsForSite/`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );
};

const addNewCampaignAPICall = (siteId, headersConfigData) => {
  try {
    return fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/AddNewCampaign`, {
      method: "POST",
      headers: headersConfigData(),
      body: JSON.stringify({ siteId: siteId })
    });
  } catch (error) {
    console.log(JSON.stringify(error));
  }
};

const saveTableCampaignDetailAPICall = (siteId, payload, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveCampaignCourseDetailForSite/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );
};

const getBaseCampaignApiCall = (siteId, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetBaseCampaignForSite?siteId=${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );
};

const getCampaignsApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetCampaignsForSite?siteId=${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const deleteCampaignAPI_CALL = (Id, headersConfigData, siteId) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteCampaign/${Id}/${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
    }
  );
};

const copyCampaignAPI_CALL = (payload, headersConfigData) => {
  return fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/CopyCampaign`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });
};

const deleteImagesAPI_CALL = (payload, headersConfigData) => {
  return fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteImages`, {
    method: "PUT",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });
};

const deleteMultipleCampaignsAPI = (payload, headersConfigData, siteId) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteCampaigns?SiteId=${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );
};

const getArchiveApiCall = (campaignId, version, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetArchiveForSite?campaignId=${campaignId}&version=${version}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

export const addImageAPI_CALL = (payload, headersConfigData, siteId) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/UploadFile?${siteId}`,
    {
      method: "POST",
      headers: headersConfigData(),
      body: payload,
    }
  );
};

const publishCampaignApiCall = (payload, headersConfigData) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PublishAdsForSite`,
    {
      method: "POST",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );
};
// ===================================================== Ads Module API Request End ==================================================== //

//======================================== Action Zone API =========================================//
const postActionZoneAPI_CALL = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/PostActionZone`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const putActionZoneAPI_CALL = (
  zoneId,
  payload,
  headersConfigData,
  siteId
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutActionZone/${zoneId}/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const deleteActionZoneAPI_CALL = (zoneId, headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/deleteActionZone/${zoneId}/${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
    }
  );
//========================================Site Setup API =========================================//

const postTeeMarkerAPI_CALL = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/PostTeeMarker`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const deleteTeeMarkerAPI_CALL = (deleteId, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeleteTeeMarker/${deleteId}/${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
      // body: JSON.stringify(payload),
    }
  );

const postPoiMarkerAPI_CALL = (payload, headersConfigData) =>
  fetch(`${process.env.REACT_APP_API_URL}/api/VisageSpa/PostPoI`, {
    method: "POST",
    headers: headersConfigData(),
    body: JSON.stringify(payload),
  });

const deletePoiMarkerAPI_CALL = (deleteId, siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/DeletePoI/${deleteId}/${siteId}`,
    {
      method: "DELETE",
      headers: headersConfigData(),
      // body: JSON.stringify(payload),
    }
  );

const putPoiMarkerAPI_CALL = (
  payload,
  payloadId,
  siteId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutPoI/${payloadId}/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const putTeeMarkerAPI_CALL = (
  payload,
  payloadId,
  siteId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutTeeMarker/${payloadId}/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const getDashboardApiCall = (
  siteId,
  courseId,
  theCurrQueryDate,
  headersConfigData
) => {
  if (siteId && courseId && theCurrQueryDate && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetDashboardCars?theSiteId=${siteId}&courseId=${courseId}&theCurrQueryDate=${theCurrQueryDate}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getDashboardRidingByCar = (
  siteId,
  courseId,
  theCurrQueryDate,
  headersConfigData
) => {
  if (siteId && courseId && theCurrQueryDate && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetDashboardRidingByCar?siteId=${siteId}&courseId=${courseId}&theCurrQueryDate=${theCurrQueryDate}`,

      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getCarSelectionApiCall = (
  siteId,
  lastQueryDate,
  courseId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetDashboardCarWithbatteryStatus?theSiteId=${siteId}&theLastQueryDate=${lastQueryDate}&CourseId=${courseId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getCarBehindPaceCountApiCall = (
  siteId,
  lastQueryDate,
  courseId,
  headersConfigData
) => {
  if (siteId && lastQueryDate && courseId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetCarsListBehindPace?theSiteId=${siteId}&theLastQueryDate=${lastQueryDate}&CourseId=${courseId}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getPreRoundCarsApiCall = (
  siteId,
  lastQueryDate,
  courseId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetPreRoundCars?theSiteId=${siteId}&theLastQueryDate=${lastQueryDate}&CourseId=${courseId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getDashboardBatteryNotificationApiCall = (
  siteId,
  currQueryDate,
  courseId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetDashboardCarWithbatteryNotification?theSiteId=${siteId}&theCurrQueryDate=${currQueryDate}&courseId=${courseId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getDashboardCampaignAdsApiCall = (
  siteId,
  currQueryDate,
  courseId,
  headersConfigData
) => {
  if (siteId && currQueryDate && courseId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetDashboardCampaignsAdsForSite?theCurrQueryDate=${currQueryDate}&siteId=${siteId}&courseId=${courseId}
      `,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

//======================================== Dashboard API Start ======================================================================//

const getPaceCarsInfo = (
  siteId,
  lastQueryDate,
  courseId,
  headersConfigData
) => {
  if (siteId && lastQueryDate && courseId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarsListBehindPace?theSiteId=${siteId}&theLastQueryDate=${lastQueryDate}&CourseId=${courseId}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getWeatherInfo = () =>
  fetch(
    `https://api.openweathermap.org/data/2.5/weather?lat=27.346962995313014&lon=-82.5383353363127&appid=314abb75e9dac8db83d35931ec313c66&units=metric`
  );

const getActionZoneInfractionData = (
  siteId,
  date,
  courseNumberGetter,
  headersConfigData
) => {
  if (siteId && date && courseNumberGetter && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetInfractionData?theSiteId=${siteId}&theLastQueryDate=${date}&CourseId=${courseNumberGetter}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getActionZoneInfractionChildData = (
  siteId,
  courseNumberGetter,
  date,
  actionZoneChild,
  headersConfigData
) => {
  if (
    siteId &&
    courseNumberGetter() &&
    date &&
    actionZoneChild &&
    headersConfigData()
  ) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetDashboardActionZoneAlertDetails?theSiteId=${siteId}&theLastQueryDate=${date}&CourseId=${courseNumberGetter()}&actionZoneInfraction=${actionZoneChild}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

//======================================== Dashboard API End ========================================================================//
const getPaceByHoleApiCall = (siteId, startDate, endDate, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetPaceByHole?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getRoundsByDayApiCall = (
  siteId,
  startDate,
  endDate,
  timeIncrement,
  startTimeHours,
  startTimeMinutes,
  endTimeHours,
  endTimeMinutes,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetRoundsByDay?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&timeIncrement=${timeIncrement}&startTimeHours=${startTimeHours}&startTimeMinutes=${startTimeMinutes}&endTimeHours=${endTimeHours}&endTimeMinutes=${endTimeMinutes}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getCarMovementApiCall = (
  siteId,
  theCurrQueryDate,
  courseId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetDashboardCarRoundMovement?theSiteId=${siteId}&theCurrQueryDate=${theCurrQueryDate}&courseId=${courseId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getFleetReadinessApiCall = (
  siteId,
  theCurrQueryDate,
  courseId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetDashboardCarMovement?theSiteId=${siteId}&theCurrQueryDate=${theCurrQueryDate}&courseId=${courseId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getRoundsCompletedApiCall = (
  siteId,
  theCurrQueryDate,
  courseId,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/DashboardRoundCompleted?siteId=${siteId}&theCurrQueryDate=${theCurrQueryDate}&courseId=${courseId}&includeMemberCars=false`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getCarUsageApiCall = (siteId, includeMemberStatus, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarUsage?siteId=${siteId}&includeMemberCars=${includeMemberStatus}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getRoundsByCarApiCall = (
  siteId,
  startDate,
  endDate,
  includeMemberStatus,
  headersConfigData
) => {
  if (
    siteId &&
    startDate &&
    endDate &&
    includeMemberStatus &&
    headersConfigData()
  ) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetRoundsByCar?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&includeMemberCars=${includeMemberStatus}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getRoundsByCarDetailsApiCall = (
  siteId,
  startDate,
  endDate,
  includeMemberStatus,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetRoundsByCarWithDetails?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&includeMemberCars=${includeMemberStatus}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );
const getCarUsageDetailsApiCall = (
  siteId,
  includeMemberStatus,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarUsageWithDetails?siteId=${siteId}&includeMemberCars=${includeMemberStatus}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getExportUsageApiCall = (
  siteId,
  includeMemberCars,
  useKMInstead,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/ExportUsage?siteId=${siteId}&includeMemberCars=${includeMemberCars}&useKMInstead=${useKMInstead}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );
const getExportRoundByCarApiCall = (
  siteId,
  includeMemberCars,
  startDate,
  endDate,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/ExportRoundsByCar?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&includeMemberCars=${includeMemberCars}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

export const getScoreCardsApiCall = (
  siteId,
  startDateData,
  endDateData,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetScoreCards?siteId=${siteId}&startDate=${startDateData}&endDate=${endDateData}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

export const getEmailAddressesApiCall = (
  siteId,
  startDateData,
  endDateData,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/GetEmailAddresses?siteId=${siteId}&startDate=${startDateData}&endDate=${endDateData}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const putResendEmailApiCall = (id, siteId, email, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL
    }/api/VisageSpa/ResendScorecard/${id}/${siteId}`,
    {
      method: "PUT",
      body: JSON.stringify(email),
      headers: headersConfigData(),
    }
  );

const getSiteAreasApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetSiteAreas?theSiteId=${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getHoleAreasApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetHoleAreas?theSiteId=${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getSingleCarTrackApiCall = (
  siteId,
  gpsiId,
  hoursBack,
  headersConfigData
) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetCarTrack?siteId=${siteId}&gpsiCarId=${gpsiId}&hoursBack=${hoursBack}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getTodayPinPosition = (
  headersConfigData,
  siteId,
  courseNumberGetter
) => {
  if (headersConfigData() && siteId && courseNumberGetter) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetTodaysPinLocation?theSiteId=${siteId}&CourseId=${courseNumberGetter}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

//######################Admin Page APIs###################################//

const getFeatureSetsApiCall = (siteId, headersConfigData) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetFeatureSets?siteId=${siteId}`,
      {
        method: "GET",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const setNewFeatureSetsApiCall = (
  newSettingsData,
  siteId,
  headersConfigData
) => {
  if (newSettingsData && siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveFeatureSets`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify(newSettingsData),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const saveCourseChangesApiCall = (
  courseData,
  siteId,
  headersConfigData
) => {
  if (courseData && siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/SaveCourseChanges/0/${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(courseData),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

const getDashboardFeatureSetApiCall = (headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetDashboardFeatureSet`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const putDashboardFeatureSetApiCall = (payload, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/SaveDashboardFeatureSet`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const putCpoSettingsApiCall = (siteId, payload, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutCpoSettings/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const putFoodEnabledApiCall = (siteId, payload, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutFoodEnabled/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
      body: JSON.stringify(payload),
    }
  );

const getFoodOrdersApiCall = (
  headersConfigData,
  siteId,
  startDate,
  endDate
) => {
  if (headersConfigData() && siteId && startDate && endDate) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetFoodOrdersData?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getFoodImageApiCall = (headersConfigData, siteId, name) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetFoodImage?siteId=${siteId}&name=${name}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getFoodImageNamesApiCall = (headersConfigData, siteId) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetFoodImageNames?siteId=${siteId}`,
    {
      method: "GET",
      headers: headersConfigData(),
    }
  );

const getFoodOrdersTabApiCall = (
  headersConfigData,
  siteId,
  startDate
) => {
  if (headersConfigData() && siteId && startDate) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetFoodOrders?siteId=${siteId}&startDate=${startDate}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getFoodMenuTabApiCall = (headersConfigData, siteId) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetFoodMenu?siteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const putFoodOrdersTabApiCall = (
  headersConfigData,
  siteId,
  order
) => {
  if (headersConfigData() && siteId && order) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutFoodOrderCompleted/${order?.OrderId
      }/${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(order),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const putLocalisationTabApiCall = (payload, headersConfigData, siteId) => {
  if (payload && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/PutLocalizationSettings/0/${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(payload),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const putTeeMarkerSettingsApiCall = (
  payloadData,
  teeMarkerId,
  siteId,
  headersConfigData
) => {
  if (payloadData && teeMarkerId && siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/PutTeeMarkerSetting/${teeMarkerId}/${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(payloadData),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const putFoodMenuApiCall = (headersConfigData, siteId, data) => {
  if (headersConfigData() && siteId && data) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/PutFoodMenu/${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(data),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const postTeeMarkerSettingsApiCall = (
  payloadData,
  siteId,
  headersConfigData
) => {
  if (payloadData && siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/PostTeeMarkerSetting`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify(payloadData),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const saveUsingSharedTeeSettingsApiCall = (
  payloadData,
  siteId,
  headersConfigData
) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/SaveUsingSharedTeeSettings/0/${siteId}`,
      {
        method: "PUT",
        headers: headersConfigData(),
        body: JSON.stringify(payloadData),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const deleteTeeSettingsApiCall = (
  itemId,
  siteId,
  headersConfigData
) => {
  if (itemId && siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/DeleteTeeMarkerSetting/${itemId}/${siteId}`,
      {
        method: "DELETE",
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const putSharedMenuCheckboxApiCall = (
  sharedChexboxValue,
  headersConfigData,
  siteId
) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `
      ${process.env.REACT_APP_API_URL
      }/api/VisageSpa/PutSharedFoodMenus/${siteId}
    `,
      {
        method: "PUT",
        body: JSON.stringify(sharedChexboxValue),
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const validateActionZonesForAllSites = (
  headersConfigData,
  siteId
) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/ValidateActionZonesForAllSites?theSiteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getPinPlacementValidationForAllSites = (
  headersConfigData,
  siteId
) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetPinPlacementValidationForAllSites?theSiteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getSiteSettingManifest = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetXMLDoc?siteId=${siteId}&xmlFileName=SiteSettings.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getSiteSettingList = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetManifestList?siteId=${siteId}&xmlFileName=SiteSettings.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getPaceManifest = (headersConfigData, siteId) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetXMLDoc?siteId=${siteId}&xmlFileName=Pace.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getPaceList = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetManifestList?siteId=${siteId}&xmlFileName=Pace.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getMessageManifest = (headersConfigData, siteId) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetXMLDoc?siteId=${siteId}&xmlFileName=Messages.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getMessageList = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetManifestList?siteId=${siteId}&xmlFileName=Messages.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getLanguageManifest = (headersConfigData, siteId) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetXMLDoc?siteId=${siteId}&xmlFileName=LanguageSettings.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getLanguageList = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetManifestList?siteId=${siteId}&xmlFileName=LanguageSettings.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getSimpleCarManifest = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetXMLDoc?siteId=${siteId}&xmlFileName=SimpleCarAhead.xml&dataType=application%2Fxml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getSimpleCarList = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetManifestList?siteId=${siteId}&xmlFileName=SimpleCarAhead.xml&dataType=application/xml`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getManifestList = (headersConfigData, siteId) => {
  if (siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetListManifestContents?siteId=${siteId}&dataType=application/json`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const postChangePasswordApiCall = (payloadData, headersConfigData) => {
  if (payloadData && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/Account/ChangePassword`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify(payloadData),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const putHoleDataApiCall = (holeData, headersConfigData, siteId) => {
  if (siteId && headersConfigData() && holeData) {
    return fetch(
      `
      ${process.env.REACT_APP_API_URL}/api/VisageSpa//PutHoleData/${holeData.Id
      }/${siteId}
    `,
      {
        method: "PUT",
        body: JSON.stringify(holeData),
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const setAdminCodeApiCall = (siteId, headersConfigData) =>
  fetch(
    `${process.env.REACT_APP_API_URL}/api/VisageSpa/GenerateAdminCode/${siteId}`,
    {
      method: "PUT",
      headers: headersConfigData(),
    }
  );

const uploadKmlApiCall = (
  payloadData,
  siteId,
  headersConfigDatafile
) => {
  if (payloadData && siteId && headersConfigDatafile()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/PostMapKml?${siteId}`,
      {
        method: "POST",
        headers: headersConfigDatafile(),
        body: payloadData,
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const createHoleMapImageDataApiCall = (siteId, headersConfigData) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/CreateHoleMapImageDataFromZipFile?${siteId}`,
      {
        method: "POST",
        headers: headersConfigData()
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const processGreenViewZipFileApiCall = (siteId, headersConfigData) => {
  if (siteId && headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/ProcessGreenViewZipFile?${siteId}`,
      {
        method: "POST",
        headers: headersConfigData()
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getMinVersForNewAZsServiceApiCall = (headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/GetMinVersForNewAZs`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const publishWaiverTemplateApiCall = (request, headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/PublishWaiverTemplate`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify(request),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const saveWaiverTemplateApiCall = (request, headersConfigData) => {
  if (headersConfigData()) {
    return fetch(
      `${process.env.REACT_APP_API_URL
      }/api/VisageSpa/SaveWaiverTemplate`,
      {
        method: "POST",
        headers: headersConfigData(),
        body: JSON.stringify(request),
      }
    );
  } else {
    return { msg: "All Parameters are required" };
  }
};

const getWaiverTemplateApiCall = (siteId, headersConfigData) => {
  if (headersConfigData() && siteId) {
    return fetch(
      `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetWaiverTemplate?siteId=${siteId}`,
      {
        headers: headersConfigData(),
      }
    );
  } else {
    return { msg: "Parameters are missing" };
  }
};

export const API_CALLS = {
  loginUser,
  getSiteSettingList,
  getPaceList,
  getLanguageList,
  getMessageList,
  getSimpleCarList,
  putSharedMenuCheckboxApiCall,
  putTeeMarkerSettingsApiCall,
  postTeeMarkerSettingsApiCall,
  deleteTeeSettingsApiCall,
  saveUsingSharedTeeSettingsApiCall,
  fetchPinsImagesApiCall,
  getFeatureSetsApiCall,
  saveCourseChangesApiCall,
  setNewFeatureSetsApiCall,
  clickToDriveApiCall,
  getExportUsageApiCall,
  getRoundsByCarDetailsApiCall,
  getCarUsageDetailsApiCall,
  getRoundsByCarApiCall,
  getActionZoneInfractionChildData,
  getActionZoneInfractionData,
  getSiteOffPeakCharginApiCall,
  getScheduledFleetLockdownApiCall,
  sendLinkToEmailForResetPasswordApiCall,
  resetUsernameApiCall,
  changePasswordApiCall,
  resetPasswordApiCall,
  disableAllAZsForMemberCarsApiCall,
  resetSiteExtentsAndCtrPtToZeroApiCall,
  createSiteDataApiCall,
  resetTeeMarkersVersionApiCall,
  resetMapsVersionApiCall,
  resetGreenViewVersionApiCall,
  resetPOIsVersionApiCall,
  clearSiteDataApiCall,
  sendTeeMarkerDataApiCall,
  scheduleSiteDataPublishApiCall,
  sendPOIDataApiCall,
  sendSiteDataApiCall,
  sendMapDataApiCall,
  sendGreenViewDataApiCall,
  resetSiteDataVersionApiCall,
  getCarsApiCall,
  putHoleAreaApiCall,
  deleteHoleAreaAPI_CALL,
  PostSiteAreaApiCall,
  putSiteAreaApiCall,
  deleteSiteAreaAPI_CALL,
  getActionZoneApiCall,
  assignManifestToCarsApiCall,
  getPackageManifestsApiCall,
  getHoleMarkerApiCall,
  getDashboardPaceApiCall,
  sendMessagesApiCall,
  getCannedMessagesApiCall,
  getMapImageApiCall,
  getXYPointsInImageApiCall,
  getSiteSettingsApiCall,
  getSiteSetupApiCall,
  setSiteSetupApiCall,
  setTeeSetupApiCall,
  setPioSetupApiCall,
  setPublishSetupApiCall,
  getMapInformationApiCall,
  getCarHistoryApiCall,
  getSpecificCarHistory,
  getCarHistoryForAllCars,
  setCurrentSettingApiCall,
  putAllowAntiTamperSelectionApiCall,
  setCurrentSettingApiCall2,
  setSaveEmailApiCall,
  setDeleteEmailApiCall,
  getAlertEmailApiCall,
  setSendTestEmailApiCall,
  setkmlLayerApiCall,
  updateEmailApiCall,
  carStagingModeAPICall,
  getMessagesHistory,
  getRolesListApiCall,
  getPrivilegesListApiCall,
  getPrivilegeApiCall,
  getAllSiteLocations,
  getCarTrackApiCall,
  getCarPropertiesApicall,
  getCarLocationApicall,
  getUserNameAndRole,
  getProductApicall,
  updateCarTypeApiCall,
  updateMemberCarTrackingLevelApiCall,
  putCOGData,
  sendFleetSettingsWelcomeText,
  getPinsApproachImagesApiCall,
  getCarPinPlacementsApiCall,
  getGreensWithPinPlacementsApiCall,
  courseRotationDataApiCall,
  getRotationDataApiCall,
  saveCourseRotationDaysApiCall,
  sendScoreCardEmail,
  putMaxHolesExAlert,
  putDisableDistance,
  putRemovePersistentCarTypeSetting,
  postSavePersistentCarTypeSetting,
  putBehindPaceWarning,
  putPaceStatusTime,
  putUpdateScheduleLockDown,
  putSiteOffPeakCharging,
  getRoundTimeOutApiCall,
  putMaxNumHoles,
  getExportRoundByCarApiCall,
  putRoundStagingTimeoutApi,
  getMessagesFromCarsApi,
  sendMessageToMarshalsApiCall,
  getPartialSiteSettingsForUpdateApi,
  getProgressPendingForSiteApi,
  getVersionStringApi,
  deleteMessagesSettingAPI_CALL,
  getVDUMessagesApiCall,
  getWelcomeAdsApiCall,
  getDashboardCartPathDetailApiCall,
  postCannedMessagesApiCall,
  postHoleAreaApiCall,
  putMessagesSettingAPI_CALL,
  putVDUMessagesApiCall,
  getImageGallaryApiCall,
  getAdImageApiCall,
  putImageDescriptionAPICall,
  deleteImageAPICall,
  deleteCampaignAPI_CALL,
  copyCampaignAPI_CALL,
  getCampaignsApiCall,
  getRoundsByDayApiCall,
  saveCampaignDetailAPICall,
  addNewCampaignAPICall,
  saveWorksheetAPICall,
  updatePinsRotationsDataApiCall,
  deleteImagesAPI_CALL,
  deleteMultipleCampaignsAPI,
  saveTableCampaignDetailAPICall,
  getBaseCampaignApiCall,
  getArchiveApiCall,
  addImageAPI_CALL,
  publishCampaignApiCall,
  postActionZoneAPI_CALL,
  putActionZoneAPI_CALL,
  enableAllAZsForMemberCarsApiCall,
  deleteActionZoneAPI_CALL,
  postTeeMarkerAPI_CALL,
  postPoiMarkerAPI_CALL,
  deleteTeeMarkerAPI_CALL,
  deletePoiMarkerAPI_CALL,
  putPoiMarkerAPI_CALL,
  putTeeMarkerAPI_CALL,
  getPaceCarsInfo,
  getDashboardApiCall,
  getDashboardRidingByCar,
  getWeatherInfo,
  getCarSelectionApiCall,
  getPaceByHoleApiCall,
  getCarMovementApiCall,
  getFleetReadinessApiCall,
  getRoundsCompletedApiCall,
  getCarUsageApiCall,
  getCarBehindPaceCountApiCall,
  getDashboardCampaignAdsApiCall,
  getScoreCardsApiCall,
  getEmailAddressesApiCall,
  putResendEmailApiCall,
  getPreRoundCarsApiCall,
  getDashboardBatteryNotificationApiCall,
  getSiteAreasApiCall,
  getHoleAreasApiCall,
  getVisageUsersApiCall,
  getVisageUsersListApiCall,
  getSiteSettingsApiCallHandler,
  getTodayPinPosition,
  getSingleCarTrackApiCall,
  getDashboardFeatureSetApiCall,
  putDashboardFeatureSetApiCall,
  putCpoSettingsApiCall,
  getCustomerServiceProfiles,
  saveCustomerServiceProfileSetting,
  getFoodOrdersApiCall,
  putFoodEnabledApiCall,
  getFoodImageApiCall,
  getFoodImageNamesApiCall,
  getFoodOrdersTabApiCall,
  putFoodOrdersTabApiCall,
  putMessagesSettingAPI_CALL2,
  getFoodMenuTabApiCall,
  putLocalisationTabApiCall,
  putFoodMenuApiCall,
  validateActionZonesForAllSites,
  getPinPlacementValidationForAllSites,
  getSiteSettingManifest,
  getPaceManifest,
  getMessageManifest,
  getLanguageManifest,
  getSimpleCarManifest,
  getManifestList,
  postChangePasswordApiCall,
  putHoleDataApiCall,
  setAdminCodeApiCall,
  putMessagesSettingAPI_CALL3,
  uploadKmlApiCall,
  createHoleMapImageDataApiCall,
  processGreenViewZipFileApiCall,
  getFaultsCall,
  putMaxVolumeSettingApiCall,
  updateEzLocatorPins,
  getMinVersForNewAZsServiceApiCall,
  setSiteExtentsApiCall,
  publishWaiverTemplateApiCall,  
  saveWaiverTemplateApiCall,
  getWaiverTemplateApiCall
};
